(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["editorial-media-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.editorial-media-carousel').forEach(function (section) {
      var track = section.querySelector('.editorial-media-carousel__track');
      if (!track) return;

      var prevBtn = section.querySelector('.editorial-media-carousel__arrow--prev');
      var nextBtn = section.querySelector('.editorial-media-carousel__arrow--next');

      function stepWidth() {
        var item = track.querySelector('.editorial-media-carousel__item');
        if (!item) return 300;
        var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || '4');
        return item.offsetWidth + gap;
      }

      function updateArrows() {
        if (!prevBtn || !nextBtn) return;
        prevBtn.disabled = track.scrollLeft <= 0;
        nextBtn.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 1;
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          track.scrollBy({ left: -stepWidth(), behavior: 'smooth' });
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          track.scrollBy({ left: stepWidth(), behavior: 'smooth' });
        });
      }

      track.addEventListener('scroll', updateArrows, { passive: true });
      updateArrows();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hp-most-popular"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.querySelectorAll('.hp-most-popular').forEach(function(section) {
      var track = section.querySelector('.hp-most-popular__track');
      if (!track) return;

      var prevBtn = section.querySelector('.hp-most-popular__arrow--prev');
      var nextBtn = section.querySelector('.hp-most-popular__arrow--next');

      function cardWidth() {
        var card = track.querySelector('.plp-card--carousel');
        if (!card) return 300;
        /* card width + gap (4px) */
        return card.offsetWidth + 4;
      }

      function updateArrows() {
        if (!prevBtn || !nextBtn) return;
        prevBtn.disabled = track.scrollLeft <= 0;
        nextBtn.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 1;
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', function() {
          track.scrollBy({ left: -cardWidth(), behavior: 'smooth' });
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function() {
          track.scrollBy({ left: cardWidth(), behavior: 'smooth' });
        });
      }

      track.addEventListener('scroll', updateArrows, { passive: true });
      /* Run once on load to set initial disabled state */
      updateArrows();
    });

    /* ── Sibling-dot hover (same logic as plp-product-grid) ── */
    document.querySelectorAll('.hp-most-popular .plp-card').forEach(function(card) {
      var primaryImg = card.querySelector('.plp-card__image:not(.plp-card__image--alt)');
      if (!primaryImg) return;
      var originalSrc = primaryImg.src;
      var originalSrcset = primaryImg.srcset || '';

      card.querySelectorAll('.plp-card__sibling-dot').forEach(function(dot) {
        dot.addEventListener('mouseenter', function() {
          var url = dot.dataset.siblingImage;
          if (!url) return;
          primaryImg.src = url;
          primaryImg.srcset = '';
          card.classList.add('plp-card--sibling-active');
        });
        dot.addEventListener('mouseleave', function() {
          primaryImg.src = originalSrc;
          primaryImg.srcset = originalSrcset;
          card.classList.remove('plp-card--sibling-active');
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-features"] && !Shopify.designMode) return;
  try {
    
(function () {
  // `root` is the document on first load, or the swapped section wrapper when
  // re-initialised after an AJAX sibling colour change.
  function initFeatures(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('.pdp-features__card').forEach(function (card) {
      if (card.dataset.featuresBound === 'true') return;

      var caption = card.querySelector('.pdp-features__card-caption');
      var body = caption ? caption.querySelector('.pdp-features__card-body') : null;
      var btn = caption ? caption.querySelector('.pdp-features__read-more') : null;
      if (!btn || !body || !caption) return;

      card.dataset.featuresBound = 'true';

      var readMore = btn.dataset.readMore || 'Read More';
      var readLess = btn.dataset.readLess || 'Read Less';

      // Hide button if text does not overflow clamp
      if (body.scrollHeight - body.clientHeight <= 1) {
        btn.hidden = true;
        return;
      }

      // Natural (collapsed) caption height, measured at expand time — it varies
      // per card now that the caption grows with a wrapping title.
      var collapsedHeight = 0;

      btn.addEventListener('click', function () {
        var expanded = btn.getAttribute('aria-expanded') === 'true';
        if (expanded) {
          // Collapse: animate caption back to its natural height
          caption.style.height = caption.scrollHeight + 'px';
          requestAnimationFrame(function () {
            caption.style.height = collapsedHeight + 'px';
          });
          setTimeout(function () {
            card.style.height = '';
            card.style.overflow = '';
            caption.style.height = '';
          }, 500);
          body.classList.add('is-clamped');
          btn.setAttribute('aria-expanded', 'false');
          btn.textContent = readMore;
        } else {
          // Expand: pin card height and enforce overflow hidden,
          // then grow caption upward pushing image out of view
          var totalHeight = card.offsetHeight;
          collapsedHeight = caption.offsetHeight;
          card.style.height = totalHeight + 'px';
          card.style.overflow = 'hidden';
          caption.style.height = collapsedHeight + 'px';
          body.classList.remove('is-clamped');
          requestAnimationFrame(function () {
            caption.style.height = totalHeight + 'px';
          });
          btn.setAttribute('aria-expanded', 'true');
          btn.textContent = readLess;
        }
      });
    });
  }

  initFeatures(document);
  document.addEventListener('shopify:section:load', function (event) {
    initFeatures(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-related-products"] && !Shopify.designMode) return;
  try {
    
  (function() {
    // `root` is the document on first load, or the swapped section wrapper when
    // re-initialised after an AJAX sibling colour change.
    function initRelated(root) {
      var scope = root && root.querySelectorAll ? root : document;

      scope.querySelectorAll('.pdp-related').forEach(function(section) {
        if (section.dataset.relatedBound === 'true') return;
        var track = section.querySelector('.pdp-related__track');
        if (!track) return;
        section.dataset.relatedBound = 'true';

        var prevBtn = section.querySelector('.pdp-related__arrow--prev');
        var nextBtn = section.querySelector('.pdp-related__arrow--next');

        function cardWidth() {
          var card = track.querySelector('.plp-card--carousel');
          if (!card) return 300;
          return card.offsetWidth + 4;
        }

        function updateArrows() {
          if (!prevBtn || !nextBtn) return;
          prevBtn.disabled = track.scrollLeft <= 0;
          nextBtn.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 1;
        }

        if (prevBtn) {
          prevBtn.addEventListener('click', function() {
            track.scrollBy({ left: -cardWidth(), behavior: 'smooth' });
          });
        }

        if (nextBtn) {
          nextBtn.addEventListener('click', function() {
            track.scrollBy({ left: cardWidth(), behavior: 'smooth' });
          });
        }

        track.addEventListener('scroll', updateArrows, { passive: true });
        updateArrows();
      });

      scope.querySelectorAll('.pdp-related .plp-card').forEach(function(card) {
        if (card.dataset.siblingHoverBound === 'true') return;
        var primaryImg = card.querySelector('.plp-card__image:not(.plp-card__image--alt)');
        if (!primaryImg) return;
        card.dataset.siblingHoverBound = 'true';

        var originalSrc = primaryImg.src;
        var originalSrcset = primaryImg.srcset || '';

        card.querySelectorAll('.plp-card__sibling-dot').forEach(function(dot) {
          dot.addEventListener('mouseenter', function() {
            var url = dot.dataset.siblingImage;
            if (!url) return;
            primaryImg.src = url;
            primaryImg.srcset = '';
            card.classList.add('plp-card--sibling-active');
          });
          dot.addEventListener('mouseleave', function() {
            primaryImg.src = originalSrc;
            primaryImg.srcset = originalSrcset;
            card.classList.remove('plp-card--sibling-active');
          });
        });
      });
    }

    initRelated(document);
    document.addEventListener('shopify:section:load', function(event) {
      initRelated(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["plp-product-grid"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.plp-card').forEach(function(card) {
    var primaryImg = card.querySelector('.plp-card__image:not(.plp-card__image--alt)');
    if (!primaryImg) return;
    var originalSrc = primaryImg.src;
    var originalSrcset = primaryImg.srcset || '';

    card.querySelectorAll('.plp-card__sibling-dot').forEach(function(dot) {
      dot.addEventListener('mouseenter', function() {
        var url = dot.dataset.siblingImage;
        if (!url) return;
        primaryImg.src = url;
        primaryImg.srcset = '';
        card.classList.add('plp-card--sibling-active');
      });
      dot.addEventListener('mouseleave', function() {
        primaryImg.src = originalSrc;
        primaryImg.srcset = originalSrcset;
        card.classList.remove('plp-card--sibling-active');
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["plp-seo-text"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-plp-seo-toggle]').forEach(function (btn) {
      var body = btn.parentElement.querySelector('[data-plp-seo-body]');
      var showLabel = btn.querySelector('[data-plp-seo-show]');
      var hideLabel = btn.querySelector('[data-plp-seo-hide]');
      if (!body || !showLabel || !hideLabel) return;

      btn.addEventListener('click', function () {
        var expanded = body.classList.toggle('is-expanded');
        btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        showLabel.hidden = expanded;
        hideLabel.hidden = !expanded;
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search-chips"]) return;
  try {
    
  (function () {
    var design = !!(window.Shopify && window.Shopify.designMode);
    var mo = null;

    function getStore() {
      return document.querySelector('[data-search-chips-store]');
    }

    function apply(target, html, isRow, fullBleed) {
      if (!target) return false;
      var hasChips = !!target.querySelector('.collection-chips__chip');
      if (hasChips && target.getAttribute('data-search-chips-html') === html) return true;
      target.innerHTML = html;
      if (isRow) target.classList.toggle('collection-chips--full-bleed', fullBleed);
      target.setAttribute('data-search-chips-html', html);
      return true;
    }

    function fill() {
      var store = getStore();
      if (!store) return;
      var html = store.innerHTML;
      if (!html || !html.trim()) return;
      
      // var chips = document.querySelectorAll('#predictive-search-results .collection-chips__chip');
      // if (chips.length > 0) {
      //   return;
      // }

      var resultsShowing =
        !!document.querySelector('.search-modal__result-count') ||
        !!document.querySelector('.predictive-search-results__no-results');
      if (resultsShowing) {
        document.querySelectorAll('[data-search-chips-html]').forEach(function (el) {
          var sec = el.closest('.search-empty__section');
          if (sec) {
            sec.remove();
          } else {
            el.innerHTML = '';
            el.removeAttribute('data-search-chips-html');
          }
        });
        return;
      }

      var fullBleed = store.getAttribute('data-full-bleed') === 'true';
      var label = store.getAttribute('data-label') || 'Categories';
      var count = store.getAttribute('data-count') || '6';

      var inner = document.querySelector('.predictive-search-results__inner');
      if (!inner) return;

      // Mobile row
      var row = inner.querySelector('.search-empty__chips-row');
      if (!row) {
        var mobile = inner.querySelector('.search-empty__mobile-content');
        if (!mobile) {
          mobile = document.createElement('div');
          mobile.className = 'search-empty__mobile-content';
          inner.insertBefore(mobile, inner.firstChild);
        }
        var sec = document.createElement('div');
        sec.className = 'search-empty__section';
        sec.innerHTML =
          '<p class="search-empty__section-label">' + label + '</p>' +
          '<div class="collection-chips search-empty__chips-row" role="list"></div>';
        mobile.insertBefore(sec, mobile.firstChild);
        row = sec.querySelector('.search-empty__chips-row');
      }
      var okRow = apply(row, html, true, fullBleed);

      // Desktop grid
      var grid = inner.querySelector('.search-empty__chips-grid');
      if (!grid) {
        var layout = inner.querySelector('.search-empty__desktop-layout');
        if (!layout) {
          layout = document.createElement('div');
          layout.className = 'search-empty__desktop-layout';
          inner.appendChild(layout);
        }
        var col = layout.querySelector('.search-empty__categories-col');
        if (!col) {
          col = document.createElement('div');
          col.className = 'search-empty__categories-col';
          layout.appendChild(col);
        }
        col.innerHTML =
          '<p class="search-empty__section-label">' + label + '</p>' +
          '<div class="collection-chips search-empty__chips-grid" role="list" style="--collection-chips-count: ' + count + ';"></div>';
        grid = col.querySelector('.search-empty__chips-grid');
      }
      apply(grid, html, false, fullBleed);
    }

    /* iOS (Safari e Firefox): dentro il dialog di ricerca la riga chip non
       riceve lo scroll nativo, quindi il gesto viene guidato a mano. Il tocco
       viene preso solo se chiaramente orizzontale, così lo scroll verticale del
       modal e il tap sulle chip restano intatti. */
    function enableTouchScroll(row) {
      if (!row || row.dataset.touchScrollBound === '1') return;
      row.dataset.touchScrollBound = '1';

      var startX = 0, startY = 0, startScroll = 0, axis = null;
      var lastX = 0, lastT = 0, velocity = 0, momentum = null;

      row.addEventListener('touchstart', function (e) {
        if (e.touches.length !== 1) return;
        if (momentum) { cancelAnimationFrame(momentum); momentum = null; }
        startX = lastX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        startScroll = row.scrollLeft;
        lastT = Date.now();
        velocity = 0;
        axis = null;
      }, { passive: true });

      row.addEventListener('touchmove', function (e) {
        if (e.touches.length !== 1) return;
        var x = e.touches[0].clientX;
        var dx = x - startX;
        var dy = e.touches[0].clientY - startY;

        if (axis === null) {
          if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return;
          axis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
        }
        if (axis !== 'x') return;

        var now = Date.now();
        var dt = now - lastT;
        if (dt > 0) velocity = (x - lastX) / dt;
        lastX = x;
        lastT = now;

        row.scrollLeft = startScroll - dx;
        if (e.cancelable) e.preventDefault();
      }, { passive: false });

      row.addEventListener('touchend', function () {
        if (axis !== 'x' || Math.abs(velocity) < 0.15) return;
        var v = velocity * 16;
        (function decelerate() {
          v *= 0.94;
          if (Math.abs(v) < 0.4) { momentum = null; return; }
          row.scrollLeft -= v;
          momentum = requestAnimationFrame(decelerate);
        })();
      }, { passive: true });
    }

    function bindTouchScroll() {
      document.querySelectorAll('.collection-chips').forEach(enableTouchScroll);
    }

    function fillAndBind() { fill(); bindTouchScroll(); }

    var scheduled = false;
    function schedule() {
      if (scheduled) return;
      scheduled = true;
      setTimeout(function () { scheduled = false; fillAndBind(); }, 0);
    }

    if (document.readyState !== 'loading') fillAndBind();
    document.addEventListener('DOMContentLoaded', fillAndBind);

    if (design || getStore()) {
      var searchModal = document.querySelector('#search-modal, .search-modal, dialog[id*="search"]');
      if (searchModal) {
        mo = new MutationObserver(schedule);
        mo.observe(searchModal, { childList: true, subtree: true });
      }
    }

    document.addEventListener('shopify:section:load', fillAndBind);
    document.addEventListener('shopify:section:select', fillAndBind);
    document.addEventListener('shopify:section:unload', fillAndBind);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search-results"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.plp-card').forEach(function(card) {
    var primaryImg = card.querySelector('.plp-card__image:not(.plp-card__image--alt)');
    if (!primaryImg) return;
    var originalSrc = primaryImg.src;
    var originalSrcset = primaryImg.srcset || '';

    card.querySelectorAll('.plp-card__sibling-dot').forEach(function(dot) {
      dot.addEventListener('mouseenter', function() {
        var url = dot.dataset.siblingImage;
        if (!url) return;
        primaryImg.src = url;
        primaryImg.srcset = '';
        card.classList.add('plp-card--sibling-active');
      });
      dot.addEventListener('mouseleave', function() {
        primaryImg.src = originalSrc;
        primaryImg.srcset = originalSrcset;
        card.classList.remove('plp-card--sibling-active');
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
